import z from 'zod'
import { isNil } from 'lodash'

// makalu-api api/upload.api.ts sends the file id only when its `uploadReturnFileId` feature is on.
export type UploadFileGateway = { fileId?: string; url: string }

// An attachment by id needs the file id, so its absence is a bug to surface, not a value to send.
export const requireFileId = ({ fileId }: UploadFileGateway): string => {
    if (isNil(fileId)) throw new Error('makalu-api returned no file id for the upload')
    return fileId
}

export interface AttachmentGateway {
    id?: string
    url: string
    label?: string
    type?: string
}

export const AttachmentWithIdsGatewaySchema = z.object({
    id: z.string(),
    label: z.string().optional(),
    type: z.string().optional(),
    url: z.string().optional()
})

export type AttachmentWithIdsGateway = z.infer<typeof AttachmentWithIdsGatewaySchema>

export interface Attachment extends AttachmentGateway {
    file: File
}
